
import React from 'react';

const Selfie = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path fill='#2d2d2d' d='M22 7H10v2h12V7z'></path>
			<path
				fill='#2d2d2d'
				d='M27 9c-1.13 0-2.16.39-3 1.03V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2c-1.65 0-3 1.35-3 3 0 .77.3 1.47.78 2-.48.53-.78 1.23-.78 2s.3 1.47.78 2c-.48.53-.78 1.23-.78 2s.3 1.47.78 2c-.48.53-.78 1.23-.78 2 0 1.65 1.35 3 3 3 0 1.1.9 2 2 2h14c2.76 0 5-2.24 5-5V10c0-.55-.45-1-1-1zM7 24c-.55 0-1-.45-1-1s.45-1 1-1v2zm0-4c-.55 0-1-.45-1-1s.45-1 1-1v2zm0-4c-.55 0-1-.45-1-1s.45-1 1-1v2zm0-4c-.55 0-1-.45-1-1s.45-1 1-1v2zm15-6v16H9V6h13zM9 26v-2h13v2H9zm17-3c0 1.3-.84 2.4-2 2.82V14c0-1.3.84-2.42 2-2.83V23z'
			></path>
			<path
				fill='#2d2d2d'
				d='M18 12.5a2.5 2.5 0 00-5 0 2.5 2.5 0 005 0zm-3 0c0-.28.22-.5.5-.5s.5.22.5.5-.22.5-.5.5-.5-.22-.5-.5zM15.5 16c-2.57 0-4.5 1.72-4.5 4 0 .55.45 1 1 1h7c.55 0 1-.45 1-1 0-2.28-1.93-4-4.5-4zm-2.2 3c.89-1.32 3.51-1.32 4.4 0h-4.4z'
			></path>
		</svg>
	);
};

export default Selfie;
